
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[user]",
      function () {
        return require("private-next-pages/user/[user].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[user]"])
      });
    }
  